import { $dms as DMSSelector } from "./Core";

export = DMSSelector;